import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import api from './api/index'
import FullCalendar from 'vue-full-calendar'
import VuePageTransition from 'vue-page-transition'
import VueToastr from "vue-toastr";

import "@/assets/css/owl.carousel.min.css"
import "@/assets/css/owl.theme.default.min.css"
import "@/assets/js/owl.carousel.min"
import "@/assets/css/index.css"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import vueAwesomeCountdown from 'vue-awesome-countdown'

import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);

Vue.use(vueAwesomeCountdown, 'vac')

// import style
import 'swiper/swiper.min.css'
import 'fullcalendar/dist/fullcalendar.css'



Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(require('vue-cookies'));
Vue.use(FullCalendar)
Vue.use(VuePageTransition)

Vue.config.productionTip = false
Vue.prototype.$API = api;
Vue.use(VueToastr, {
  defaultTimeout: 3000,
  defaultProgressBar: false,
  defaultProgressBarValue: 0,
  // defaultType: "error",
  defaultPosition: "toast-bottom-center",
  defaultCloseOnHover: false,
  // defaultClassNames: ["animated", "zoomInUp"]
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
